import { useTheme } from "@mui/material";

const ResultColours = () => {
  const theme = useTheme();

  const colours_main = {
    Realistic: {
      paletteName: "pink",
      colour: theme.palette.pink.main,
    },
    Investigative: {
      paletteName: "orange",
      colour: theme.palette.orange.main,
    },
    Artistic: {
      paletteName: "teal",
      colour: theme.palette.teal.main,
    },
    Social: {
      paletteName: "green",
      colour: theme.palette.green.main,
    },
    Enterprising: {
      paletteName: "blue",
      colour: theme.palette.blue.main,
    },
    Conventional: {
      paletteName: "purple",
      colour: theme.palette.purple.main,
    },
  };

  return { colours_main };
};

export default ResultColours;
